module.exports = __webpack_public_path__ + "img/4_128.f829c7bd.png";